import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const optimizerComponent: ComponentDef = {
  id: 'optimizer',
  name: 'Optimizer',
  description: 'First and second moment updates for Adam, AdamW, Lion, and SGD.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    {
      name: 'variant',
      label: 'Optimizer',
      type: 'select',
      default: 'adamw',
      options: [
        { label: 'Adam', value: 'adam' },
        { label: 'AdamW', value: 'adamw' },
        { label: 'Lion', value: 'lion' },
        { label: 'SGD + Momentum', value: 'sgd' }
      ]
    }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const variant = String(params.variant || 'adamw');

    const g = new GraphBuilder();
    g.input('grad', [d_model, d_model]);

    if (variant === 'sgd') {
      // SGD + Momentum: only momentum buffer, no 2nd moment
      // v = β*v + grad
      g.scale('beta_v', 'grad', 'β·v  (momentum decay)');
      g.add('v', 'beta_v', 'grad');
      // param -= lr * v
      g.scale('update', 'v', '−lr  (SGD+M step)');
      g.add('param', 'grad', 'update');
      g.output('out', 'param');
    } else {
      // Adam / AdamW / Lion: 1st and 2nd moment paths
      g.scale('m', 'grad', '1st moment');
      g.scale('v', 'grad', '2nd moment');
      g.scale('lr', 'v', 'LR');
      g.scale('update', 'lr', variant);
      g.add('param', 'grad', 'update');
      g.output('out', 'param');
    }

    return g.build();
  }
};
